/* eslint-disable @nx/enforce-module-boundaries */
import { Compiler, Injectable, Injector, NgModuleFactory, inject } from '@angular/core';

import { LocaleService } from '@frontend/oxygen/core';
import { sbdesktop } from '@frontend/oxygen/core-locale';

@Injectable({
    providedIn: 'root',
})
export class LDHostAppService {
    private compiler = inject(Compiler);
    private injector = inject(Injector);
    private localeService = inject(LocaleService);

    onAppInit(): void {
        this.generateModules();
    }

    private generateModules(): void {
        // Using Record type for better type safety
        const paths: Record<string, Promise<any>> = {
            '@lazy-modules/locale/translation.module': import('../../../../../ladbrokes-desktop-app/src/lazy-modules/locale/translation.module').then(
                (module) => module.TranslationModule,
            ),
            '@lazy-modules/performanceMark/performanceMark.module': import('@frontend/oxygen/core-performancemark').then(
                (module) => module.PerformanceMarkModule,
            ),
            '@lazy-modules/awsFirehose/awsFirehose.module': import('@frontend/oxygen/core-awsfirehose').then((module) => module.AWSFirehoseModule),
            '@lazy-modules/flagSource/flag-source.module': import('@frontend/oxygen/core-flagsource').then((module) => module.FlagSourceModule),
            '@lazy-modules/arcUser/arcUser.module': import('@frontend/oxygen/core-arcuser').then((module) => module.ArcUserModule),
            '@lazy-modules/serviceClosure/service-closure.module': import('@frontend/oxygen/core-serviceclosure').then(
                (module) => module.ServiceClosureModule,
            ),
            '@lazy-modules/freeRideHelper/freeRideHelper.module': import('@frontend/oxygen/core-freeridehelper').then(
                (module) => module.FreeRideHelperModule,
            ),
            '@ladbrokesDesktop/lazy-modules/luckyDip/lucky-dip-lazy.module': import(
                '../../../../../ladbrokes-desktop-app/src/lazy-modules/luckyDip/lucky-dip-lazy.module'
            ).then((module) => module.LuckyDipLazyModule),
        };

        // Using Promise.all for better handling of multiple async operations
        const modulePromises = Object.entries(paths).map(([_path, importPromise]) =>
            importPromise.then((loadedModule) => this.loadModuleFactory(loadedModule)).then((moduleFactory) => moduleFactory.create(this.injector)),
        );

        Promise.all(modulePromises).finally(() => {
            this.localeService.setLangData(sbdesktop);
        });
    }

    private loadModuleFactory(loadedModule: any): Promise<NgModuleFactory<any>> {
        if (loadedModule instanceof NgModuleFactory) {
            return Promise.resolve(loadedModule);
        } else {
            return this.compiler.compileModuleAsync(loadedModule);
        }
    }
}
